// 🔧 sponsor_generator.js
// ✅ Purpose: Generates sponsor demo data for the Sponsor Engine
// ✅ Features:
// - Generates Sponsor Levels
// - Generates Sponsors
// - Industry-aware through DemoContext
// - No Firestore writes
// - No DemoContext mutation
// - Fully block-commented for clarity and future devs

import { buildSponsorLevels } from "./templates/sponsor_level_defaults";
import { buildSponsorsFromLevels } from "./templates/sponsor_defaults";

export const generateSponsors = ({
  demoContext,
} = {}) => {
  console.log("🎁 Sponsor Generator started.");

  // =====================================================
  // Determine which industry template is active.
  // =====================================================

  const industryTemplate =
    demoContext?.industryTemplate?.key ||
    demoContext?.demoConfig?.industry ||
    "car_show";

  // =====================================================
  // Generate sponsor levels.
  // =====================================================

  const sponsorLevels =
    buildSponsorLevels({
      industryTemplate,
    });

  // =====================================================
  // Generate sponsors using those levels.
  // =====================================================

  const sponsors =
    buildSponsorsFromLevels({
      industryTemplate,
      sponsorLevels,
    });

  console.log("✅ Sponsor Generator completed.", {
    sponsorLevels: sponsorLevels.length,
    sponsors: sponsors.length,
  });

  return {
    sponsorLevels,
    sponsors,
  };
};
